/**
 * Constructs a search method based on the provided search data and search by field.
 *
 * @param {Object} searchData - The search data object containing VIN, license plate, and state.
 * @param {string} searchBy - The search by field (either 'vin' or 'plate').
 * @returns {Object} The constructed search method.
 */
export function constructClaimedVehicleQueryParam(
  searchData: {
    vin: string;
    license_plate: string;
    state: string;
  },
  searchBy: string
) {
  const vehicleClaimed = {
    vin: { vin: searchData?.vin },
    plate: {
      license_plate: searchData?.license_plate,
      state: searchData?.state,
    },
  };

  // Get the search method based on searchBy
  return vehicleClaimed[searchBy as keyof typeof vehicleClaimed];
}
